import { SagaIterator } from 'redux-saga';
import { PROFILE_LATEST_ACTIVITY } from 'src/modules/profile/actions/ProfileActions';
import { put } from 'typed-redux-saga';

export function* scheduleUpdateLatestActivity(): SagaIterator<void> {
  yield* put(PROFILE_LATEST_ACTIVITY.request());
}
